<nav
    class="navbar navbar-expand-md"
    (closePopup)="closePopup()"
>

     <button
        class="navbar-toggler visible-xs"
        type="button"
        (click)="toggleNavbar()"
        styleClass="ui-button-info"
    >
        <div
            class="animated-icon"
            [ngClass]="{ open: navbarOpen }"
        >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
     </button>
    <div
        class="collapse navbar-collapse"
        [ngClass]="{ show: navbarOpen }"
    >
        <app-side-menu></app-side-menu>
    </div>
</nav>
